module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./XBLWarehouseView.js"));
	}, "XBLWarehouseView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=XBLWarehouseView!./src/pages/Shop/Member/Personal/XBLWarehouse/XBLWarehouseView.js
// module id = 1519
// module chunks = 418